/**
 * Service: membershipApi
 */
angular.module('acme.common.service.membershipApi', [
  'acme.common.factory.QueryStringBuilder',
  'acme.common.factory.apiVersion'
])
.service('MembershipApiService', [ '$http', 'QueryStringBuilderFactory', 'ApiVersionFactory', function($http, QueryStringBuilderFactory, ApiVersionFactory) {

    return {

      service: '',
      endpoint: '',

      init: function (endpoint) {
        this.service = endpoint + '/memberships';
        this.endpoint = endpoint;
        this.summaries.service = endpoint + '/membership/summaries';
        this.categories.service = endpoint + '/membership/levels';
        this.categories.collection.service = endpoint + '/membership/levels/collection';
        this.offerings.service = endpoint + '/membership/offerings';
        this.offerings.endpoint = endpoint;
        this.types.service = endpoint + '/membership/types';
        this.eligibility.service = endpoint + '/membership/eligibleoptions';
        this.benefits.service = endpoint + '/membership/benefits';
        this.cards.layouts.service = endpoint + '/membership/cards/layouts';
        this.lifecycle.discounts.service = endpoint + '/membership/lifecycleaction/discounts';
        this.lifecycle.forms.service = endpoint + '/membership/lifecycleaction/forms';
        this.categories.collection.service = this.categories.service + '/collection';
        this.cardholders.service = endpoint + '/membership/cards';
        this.validate.service = endpoint + '/memberships';
        this.versions.service = endpoint + '/membership/versions'
      },

      list: function() {
        var av = new ApiVersionFactory();

        return $http({
          method: 'get',
          url: av.init({ url: this.service, version: 'v2' })
        });
      },

      categoriesList: function(props) {
        var q = '',
          av = new ApiVersionFactory();

        if (props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              requires: ['isPublished'],
              optional: ['pageSize', 'page', 'sortField', 'sortDirection']
            }
          });
          q = qs.query;
        }

        return $http({
          method: 'get',
          url: av.init({url: this.endpoint + '/membership/categories' + q, version: 'v2'})
        });
      },

      detail: function(id) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'get',
          url: av.init({ url: this.service + '/' + id, version: 'v2' })
        });
      },
      
      sendDigitalCardEmail: function(membershipId) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'post',
          url: av.init({ url: this.endpoint + '/membership/' + membershipId + '/email', version: 'v2' })
        });
      },

      /**
       * @param {{ id: string; notes: string; }} props 
       * @returns {Promise<any>}
       */
      notes: function(props) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'post',
          url: av.init({ url: this.service + '/' + props.id + '/notes', version: 'v2' }),
          data: {
            notes: props.notes
          }
        });
      },

      create: function(props) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'post',
          url: av.init({ url: this.service, version: 'v2' }),
          data: {
            membershipMethod: props.membershipMethod,
            level: props.level,
            importId: props.importId,
            membershipTypeId: props.membershipTypeId,
            externalMembershipId: props.externalMembershipId,
            membershipJoinedDate: props.membershipJoinedDate,
            membershipStartDate: props.membershipStartDate,
            membershipExpirationDate: props.membershipExpirationDate,
            membershipStanding: props.membershipStanding,
            membershipCategory: props.membershipCategory,
            categoryId: props.categoryId,
            cardHolders: props.cardHolders,
            entitlements: props.entitlements,
            offeringId: props.offeringId,
            pricePointId: props.pricePointId,
            organizationId: props.organizationId,
            orgImportId: props.orgImportId
          }
        });
      },

      update: function(props) {
        return $http({
          method: 'put',
          url: this.service,
          data: props
        });
      },

      batch: function(props) {
        return $http({
          method: 'put',
          url: this.service,
          data: {}
        });
      },

      remove: function(id) {
        return $http({
          method: 'delete',
          url: this.service + '/' + id
        });
      },

      recent: function(id) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'get',
          url: av.init({ url: this.service + '/recent/' + id, version: 'v2' })
        });
      },

      deleteCardholder: function(props) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'delete',
          url: av.init({ url: this.service + '/' + props.membershipId + '/cards/' + props.id, version: 'v2' })
        });
      },

      versions: {

        service: '',

        setLatest: function(id) {
          var av = new ApiVersionFactory();
          return $http({
            method: 'put',
            url: av.init({ url: this.service + '/latest/' + id, version: 'v2' })
          });
        },

        archive: function(membershipId) {
          return $http({
            method: 'post',
            url: '/v2/api/membership/versions/archive/' + membershipId,
            data: {}
          });
        },

        unarchive: function(membershipId) {
          return $http({
            method: 'post',
            url: '/v2/api/membership/versions/unarchive/' + membershipId,
            data: {}
          });
        },
      },

      summaries: {

        service: '',

        list: function(props) {
          var q = '',
              av = new ApiVersionFactory();

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'membershipId', 'type', 'cardholders', 'firstName', 'lastName', 'email', 'search']
              }
            });
            q = qs.query;
          }

          return $http({
            method: 'get',
            url: av.init({url: this.service + q, version: 'v2'})
          });
        },

        search: function(props) {
          var q = '',
              av = new ApiVersionFactory();

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'corporate', 'cardType', 'search']
              }
            });
            q = qs.query;
          }

          return $http({
            method: 'get',
            url: av.init({url: this.service + '/search' + q, version: 'v2'})
          });
        },
        
        advancedSearch: function(props) {
          var q = '';
          var av = new ApiVersionFactory();

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: [
                  'pageSize',
                  'page',
                  'sortField',
                  'sortDirection',
                  'firstName',
                  'lastName',
                  'address',
                  'zip',
                  'email',
                  'memberId',
                  'cardName',
                ]
              }
            });

            q = qs.query;
          }

          return $http({
            method: 'get',
            url: av.init({ url: this.service + '/advancedsearch' + q, version: 'v2' })
          });
        },

        exactSearch: function(props) {
          var q = '';

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: [
                  'pageSize',
                  'page',
                  'sortField',
                  'sortDirection',
                  'firstName',
                  'lastName',
                  'email',
                  'memberId',
                  'barcode',
                ]
              }
            });

            q = qs.query;
          }

          return $http({
            method: 'get',
            url: '/v2/api/membership/summaries/exactsearch' + q,
          });
        },

      },

      types: {

        service: '',

        list: function(props) {
          var q = '',
              av = new ApiVersionFactory();

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search', 'unusedTypes', 'levelId', 'offeringId']
              }
            });
            q = qs.query;
          }

          return $http({
            method: 'get',
            url: av.init({url: this.service + q, version: 'v2'})
          });
        }

      },

      benefits: {

        service: '',

        list: function(props) {

          var q = '',
              av = new ApiVersionFactory();

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
              }
            });
            q = qs.query;
          }

          return $http({
            method: 'get',
            url: av.init({ url: this.service + q, version: 'v2' })
          });

        },

        create: function(props) {

          var av = new ApiVersionFactory();

          return $http({
            method: 'post',
            url: av.init({ url: this.service, version: 'v2' }),
            data: {
              description: props.description
            }
          });

        },

        update: function(props) {

          var av = new ApiVersionFactory();

          return $http({
            method: 'put',
            url: av.init({ url: this.service, version: 'v2' }),
            data: {
              id: props.id,
              description: props.description
            }
          });

        },

        remove: function(props) {

          var av = new ApiVersionFactory();

          return $http({
            method: 'delete',
            url: av.init({ url: this.service + '/' + props.id, version: 'v2' })
          });

        }

      },

      categories: {

        service: '',

        list: function(props) {
          var q = '',
              av = new ApiVersionFactory();

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                requires: ['salesChannels', 'isPublished'],
                optional: ['summarize','pageSize', 'page', 'sortField', 'sortDirection', 'search', 'membershipLevelGroup', 'auxiliary', 'collectionId', 'excludeLevelsWithACollection']
              }
            });
            q = qs.query;
          }

          return $http({
            method: 'get',
            url: av.init({url: this.service + q, version: 'v2'})
          });
        },

        /**
         * @param {string} id 
         * @returns IPromise<any>
         */
        detail: function(id) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'get',
            url: av.init({url: this.service + '/' + id, version: 'v2'})
          });
        },

        create: function(props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'post',
            url: av.init({url: this.service, version: 'v2'}),
            data: {
              name: props.name,
              subtitle: props.subtitle,
              description: props.description,
              shortDescription: props.shortDescription,
              confirmationMessage: props.confirmationMessage,
              benefits: props.benefits,
              membershipLevelGroup: props.membershipLevelGroup,
              defaultType: props.defaultType,
              types: props.types,
              price: props.price,
              salesChannels: props.salesChannels,
              durationInMonths: props.durationInMonths,
              images: props.images,
              state: props.state,
              offerings: props.offerings,
              rules: {
                numberOfCardHolders: props.rules.numberOfCardHolders,
                canGift: props.rules.canGift,
                startBeginningOfMonth: props.rules.startBeginningOfMonth,
                expireEndOfMonth: props.rules.expireEndOfMonth
              },
              auxiliary: props.auxiliary,
              membershipLevelCollection: props.membershipLevelCollection
            }
          });
        },

        update: function(props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'put',
            url: av.init({url: this.service, version: 'v2'}),
            data: {
              id: props.id,
              name: props.name,
              subtitle: props.subtitle,
              description: props.description,
              shortDescription: props.shortDescription,
              confirmationMessage: props.confirmationMessage,
              benefits: props.benefits,
              membershipLevelGroup: props.membershipLevelGroup,
              defaultType: props.defaultType,
              types: props.types,
              price: props.price,
              salesChannels: props.salesChannels,
              durationInMonths: props.durationInMonths,
              images: props.images,
              state: props.state,
              offerings: props.offerings,
              displayOrder: props.displayOrder,
              rules: {
                numberOfCardHolders: props.rules.numberOfCardHolders,
                canGift: props.rules.canGift,
                startBeginningOfMonth: props.rules.startBeginningOfMonth,
                expireEndOfMonth: props.rules.expireEndOfMonth
              },
              auxiliary: props.auxiliary,
              membershipLevelCollection: props.membershipLevelCollection
            }
          });
        },


        updateDisplayOrder: function(props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'put',
            url: av.init({url: (this.service + '/displayorder'), version: 'v2'}),
            data: props
          });
        },

        publish: function(props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'put',
            url: av.init({url: this.service + '/publish', version: 'v2'}),
            data: {
              id: props.id,
              name: props.name,
              subtitle: props.subtitle,
              description: props.description,
              shortDescription: props.shortDescription,
              confirmationMessage: props.confirmationMessage,
              benefits: props.benefits,
              membershipLevelGroup: props.membershipLevelGroup,
              defaultType: props.defaultType,
              types: props.types,
              price: props.price,
              salesChannels: props.salesChannels,
              durationInMonths: props.durationInMonths,
              images: props.images,
              state: props.state,
              offerings: props.offerings,
              displayOrder: props.displayOrder,
              rules: {
                numberOfCardHolders: props.rules.numberOfCardHolders,
                canGift: props.rules.canGift,
                startBeginningOfMonth: props.rules.startBeginningOfMonth,
                expireEndOfMonth: props.rules.expireEndOfMonth
              },
              auxiliary: props.auxiliary,
              membershipLevelCollection: props.membershipLevelCollection
            }
          });
        },

        remove: function(props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'delete',
            url: av.init({url: this.service + '/' + props.id, version: 'v2'})
          });
        },
        
        collection: {
          service: '',

          list: function(props) {
            var av = new ApiVersionFactory(),
                q = '';

            if (props) {
              var qs = new QueryStringBuilderFactory({
                props: props,
                fields: {
                  optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
                }
              });

              q = qs.query;
            }

            return $http({
              method: 'get',
              url: av.init({ url: this.service + q, version: 'v2' })
            });
          },

          detail: function(id) {
            var av = new ApiVersionFactory();
            
            return $http({
              method: 'get',
              url: av.init({ url: this.service + '/' + id, version: 'v2' })
            });
          },

          create: function(props) {
            var av = new ApiVersionFactory();

            return $http({
              method: 'post',
              url: av.init({ url: this.service, version: 'v2' }),
              data: props
            });
          },

          update: function(props) {
            var av = new ApiVersionFactory();

            return $http({
              method: 'put',
              url: av.init({ url: this.service, version: 'v2' }),
              data: props
            });
          },

          remove: function(id) {
            var av = new ApiVersionFactory();

            return $http({
              method: 'delete',
              url: av.init({ url: this.service + '/' + id, version: 'v2' })
            });
          },

          updateDisplayOrder: function(props) {
            var av = new ApiVersionFactory();

            return $http({
              method: 'put',
              url: av.init({url: (this.service + '/displayorder'), version: 'v2'}),
              data: props
            });
          }
        }

      },

      eligibility: {

        service: '',

        list: function(props) {
          var q = '',
              av = new ApiVersionFactory();

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
              }
            });
            q = qs.query;
          }

          return $http({
            method: 'get',
            url: av.init({ url: this.service + q, version: 'v2' })
          });
        },

        detail: function(id) {
          var q = '',
              av = new ApiVersionFactory();

          return $http({
            method: 'get',
            url: av.init({ url: this.service + '/' + id, version: 'v2' })
          });
        },

        create: function(props) {
          var q = '',
              av = new ApiVersionFactory();

          return $http({
            method: 'post',
            url: av.init({ url: this.service, version: 'v2' }),
            data: props
          });
        },

        update: function(props) {
          var q = '',
              av = new ApiVersionFactory();

          return $http({
            method: 'put',
            url: av.init({ url: this.service, version: 'v2' }),
            data: props
          });
        },

        remove: function(id) {
          var q = '',
              av = new ApiVersionFactory();

          return $http({
            method: 'delete',
            url: av.init({ url: this.service + '/' + id, version: 'v2' })
          });
        },

        listByMembershipCategory: function(props) {
          var q = '', qs,
              av = new ApiVersionFactory();

          qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              requires: ['membershipId'],
              optional: ['saleChannels', 'actions', 'summarize']
            }
          });

          q = qs.query;
          return $http({
            method: 'get',
            url: av.init({url: this.service + '/levels/' + q, version: 'v2'})
          });
        },

      },

      offerings: {

        service: '',
        endpoint: '',

        list: function (props) {

          var q = '',
            av = new ApiVersionFactory();

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
              }
            });
            q = qs.query;
          }

          return $http({
            method: 'get',
            url: av.init({
              url: this.endpoint + '/membership/levels/' + props.categoryId + '/membershipofferings' + q,
              version: 'v2'
            })
          });

        },

        summaries: function (props) {

          var q = '',
            av = new ApiVersionFactory();

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['offeringId', 'levelId', 'isDraftId']
              }
            });
            q = qs.query;
          }

          return $http({
            method: 'get',
            url: av.init({
              url: this.endpoint + '/membership/summaries/offering' + q,
              version: 'v2'
            })
          });
        },

        create: function (props) {

          var av = new ApiVersionFactory();

          return $http({
            method: 'post',
            url: av.init({
              url: this.endpoint + '/membership/levels/' + props.categoryId + '/membershipofferings',
              version: 'v2'
            }),
            data: {
              name: props.name,
              subtitle: props.subtitle,
              description: props.description,
              duration: props.duration,
              benefits: props.benefits,
              rules: props.rules,
              actions: props.actions,
              priceLists: props.priceLists,
              startTime: props.startDate,
              endTime: props.endDate,
              autorenewalType: props.autorenewalType
            }
          });

        },

        update: function (props) {

          var av = new ApiVersionFactory();

          return $http({
            method: 'put',
            url: av.init({
              url: this.endpoint + '/membership/levels/' + props.categoryId + '/membershipofferings',
              version: 'v2'
            }),
            data: {
              id: props.id,
              name: props.name,
              subtitle: props.subtitle,
              description: props.description,
              duration: props.duration,
              benefits: props.benefits,
              rules: props.rules,
              actions: props.actions,
              priceLists: props.priceLists,
              startTime: props.startDate,
              endTime: props.endDate,
              types: props.types,
              defaultType: props.defaultType,
              autorenewalType: props.autorenewalType
            }
          });

        },

        detail: function (props) {

          var av = new ApiVersionFactory();

          return $http({
            method: 'get',
            url: av.init({
              url: this.endpoint + '/membership/levels/' + props.categoryId + '/membershipofferings/' + props.offeringId,
              version: 'v2'
            })
          });

        },

        remove: function (props) {

          var av = new ApiVersionFactory();

          return $http({
            method: 'delete',
            url: av.init({url: this.endpoint  + '/membership/levels/' + props.categoryId + '/membershipofferings/' + props.offeringId, version: 'v2'})
          });

        }

      },

      cards: {

        layouts: {

          service: '',

          list: function(props) {
            var q = '',
                av = new ApiVersionFactory();

            if (props) {
              var qs = new QueryStringBuilderFactory({
                props: props,
                fields: {
                  optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search', 'active']
                }
              });
              q = qs.query;
            }
            return $http({
              method: 'get',
              url: av.init({
                url: this.service + q,
                version: 'v2'
              })
            });
          },

          detail: function(id) {
            var av = new ApiVersionFactory();
            return $http({
              method: 'get',
              url: av.init({
                url: this.service + '/' + id,
                version: 'v2'
              })
            });
          },

          create: function(props) {
            var av = new ApiVersionFactory();
            return $http({
              method: 'post',
              url: av.init({
                url: this.service,
                version: 'v2'
              }),
              data: props
            });
          },

          update: function(props, publish) {
            var q = '',
                av = new ApiVersionFactory();

            if (publish) {
              var qs = new QueryStringBuilderFactory({
                props: { publish: publish },
                fields: {
                  optional: ['publish']
                }
              });
              q = qs.query;
            }

            return $http({
              method: 'put',
              url: av.init({
                url: this.service + q,
                version: 'v2'
              }),
              data: props
            });
          },

          remove: function(id) {
            var av = new ApiVersionFactory();
            return $http({
              method: 'delete',
              url: av.init({
                url: this.service + '/' + id,
                version: 'v2'
              })
            });
          }

        }
      },

      lifecycle: {

        discounts: {

          service: '',

          list: function(props) {
            var q = '',
                av = new ApiVersionFactory();

            if (props) {
              var qs = new QueryStringBuilderFactory({
                props: props,
                fields: {
                  optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search', 'lifecycleActions', 'membershipLevelIds', 'membershipOfferingIds', 'discountIds', 'couponCategoryIds']
                }
              });
              q = qs.query;
            }
            return $http({
              method: 'get',
              url: av.init({
                url: this.service + q,
                version: 'v2'
              })
            });
          },

          detail: function(id) {
            var av = new ApiVersionFactory();
            return $http({
              method: 'get',
              url: av.init({
                url: this.service + '/' + id,
                version: 'v2'
              })
            });
          },

          create: function(props) {
            var av = new ApiVersionFactory();
            return $http({
              method: 'post',
              url: av.init({
                url: this.service,
                version: 'v2'
              }),
              data: props
            });
          },

          update: function(props) {
            var av = new ApiVersionFactory();

            return $http({
              method: 'put',
              url: av.init({
                url: this.service,
                version: 'v2'
              }),
              data: props
            });
          },

          remove: function(id) {
            var av = new ApiVersionFactory();
            return $http({
              method: 'delete',
              url: av.init({
                url: this.service + '/' + id,
                version: 'v2'
              })
            });
          }

        },

        forms: {
          service: '',

          create: function(props) {
            var av = new ApiVersionFactory();
            return $http({
              method: 'post',
              url: av.init({
                url: this.service,
                version: 'v2'
              }),
              data: props
            });
          },

          update: function (props) {
            var av = new ApiVersionFactory();
            return $http({
              method: 'put',
              url: av.init({
                url: this.service,
                version: 'v2'
              }),
              data: props
            });
          },

          list: function(props) {
            var q = '',
                av = new ApiVersionFactory();

            if (props) {
              var qs = new QueryStringBuilderFactory({
                props: props,
                fields: {
                  optional: [
                    'lifecycleActions',
                    'membershipLevelIds',
                    'membershipOfferingIds',
                    'formIds',
                    'formMappingIds',
                    'page',
                    'pageSize',
                  ],
                },
              });
              q = qs.query;
            }

            return $http({
              method: 'get',
              url: av.init({
                url: this.service + q,
                version: 'v2'
              })
            });
          },

          remove: function(props) {
            var av = new ApiVersionFactory();
  
            return $http({
              method: 'delete',
              url: av.init({url: this.service + '/' + props.id, version: 'v2'})
            });
          },

          detail: function(props) {
            var av = new ApiVersionFactory();
  
            return $http({
              method: 'get',
              url: av.init({url: this.service + '/' + props.id, version: 'v2'})
            });
          },
        }
      },

      layouts: {
        list: function() {
          return $http({
            method: 'get',
            url: '/assets/data/membership_layout.json?v=2'
          });
        }
      },

      cardholders: {
        detail: function(id) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'get',
            url: av.init({ url: this.service + '/' + id, version: 'v2' })
          });
        }
      },

      validate: {
        detail: function(props) {
          var q = '',
              av = new ApiVersionFactory();

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                requires: ['action', 'levelId', 'offeringId', 'pricePointId'],
                optional: ['membershipId']
              }
            });
            q = qs.query;
          }

          return $http({
            method: 'get',
            url: av.init({ url: this.service + '/checkout/validate' + q, version: 'v2' })
          });
        }
      }

    };

}]);
